const PREFIX = 'TIPS';

export const LIST_TIPS = `${PREFIX}/LIST`;
export const RETRIEVE_TIP = `${PREFIX}/RETRIEVE`;
export const RANDOM_TIP = `${PREFIX}/RANDOM`;
export const CREATE_TIP = `${PREFIX}/CREATE`;
export const UPDATE_TIP = `${PREFIX}/UPDATE`;
export const SET_FILTER_TIP = `${PREFIX}/SET_FILTER`;
